import { render, staticRenderFns } from "./key-visual.vue?vue&type=template&id=74764e9b&scoped=true"
import script from "./key-visual.vue?vue&type=script&lang=js"
export * from "./key-visual.vue?vue&type=script&lang=js"
import style0 from "./key-visual.vue?vue&type=style&index=0&id=74764e9b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74764e9b",
  null
  
)

export default component.exports